import CustomButton from 'components/buttons/CustomButton/CustomButton'
import CustomDialog from 'components/dialogs/CustomDialog'
import { useAuth } from 'context/AuthContext';
import { useRegistryContext } from 'context/RegistryContext';
import { useDeleteProcedures } from 'hooks/useProcedure';
import { useDeleteRegistryPatients } from 'hooks/useRegistryPatient';
import React from 'react'
import { snackbarService } from 'services/snackbarService';

interface Props {
  open: boolean;
  setOpen: (value: boolean) => void;
  procedureIds: number[];
  refetch?: () => void;
  after?: () => void;
}
export default function DeleteRegistryPatientsDialog({
  open,
  setOpen,
  procedureIds,
  refetch,
  after,
}: Props) {
  const { user } = useAuth();
  const { registry } = useRegistryContext();

  const { mutate: deleteMutation, isLoading } = useDeleteRegistryPatients(
    (res: any) => {
      const { data, status_code: statusCode } = res;
      if (statusCode == 200) {
        refetch?.();
        setOpen(false);
        after?.();
        snackbarService.showSnackbar('Patients have been deleted successfully', 'success');
      } else {
        snackbarService.showSnackbar(data, 'error');
      }
    },
    (error: any) => {
      setOpen(false);
    }
  );

  const handleConfirmDelete = () => {
    deleteMutation({
      registryId: registry.id,
      patientIds: procedureIds,
    });
  };


  return (
    <CustomDialog
      open={open}
      title={`Delete ${procedureIds?.length == 1 ? 'Patient' : 'Patients'}`}
      message={`Note: Deleting patients is permenant and cannot be undone.`}
      alignText='left'
      buttons={[
        <CustomButton
          key='cancel'
          variant='outlined'
          text='Cancel'
          textColor='error'
          onClick={() => setOpen(false)}
          disabled={isLoading}
          height={35}
        />,
        <CustomButton
          key='delete'
          variant='filled'
          color='error'
          text='Delete anyway'
          onClick={handleConfirmDelete}
          loading={isLoading}
          height={35}
        />,
      ]}
    />
  )
}
